import styled, { css } from 'styled-components';

export const TicketItemWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-flow: row nowrap;
  margin-bottom: 0.5rem;
  ${(props) => props.noMargin
    && css`
      margin: 0;
    `}
  ${(props) => props.withBorders
    && css`
      background-color: inherit;
      border: 1px solid var(--border-color);
      border-radius: 0.25rem;
      padding: 0.25em 0;
    `};
`;

export const TicketItemTitle = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex: 1 1 auto;
  align-items: center;
  padding: 0.5em 1em;
  ${(props) => props.noPadding
    && css`
      padding: 0 1em;
    `}
`;

export const TicketItemValue = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex: 0 0 130px;
  align-items: center;
  border-left: 1px solid var(--border-color);
  padding: 0.5em 1em;
  ${(props) => props.noPadding
    && css`
      padding: 0 1em;
    `}
`;
